import { supabase } from '../lib/supabase';
import { logger } from '../utils/logger';

/**
 * Get all system AI prompts
 */
export async function getSystemAIPrompts() {
  try {
    const { data, error } = await supabase
      .from('system_ai_prompts')
      .select('*')
      .order('created_at', { ascending: false });

    if (error) throw error;
    return data || [];
  } catch (error) {
    logger.error('Error fetching system AI prompts:', error);
    throw error;
  }
}

/**
 * Get a single system AI prompt by ID
 */
export const getSystemAIPromptById = async (promptId) => {
  try {
    const { data, error } = await supabase
      .from('system_ai_prompts')
      .select('*')
      .eq('id', promptId)
      .single();

    if (error) throw error;
    return data;
  } catch (error) {
    logger.error('Error fetching system AI prompt:', error);
    throw error;
  }
};

/**
 * Create a new system AI prompt
 */
export const createSystemAIPrompt = async (promptData) => {
  try {
    const { data, error } = await supabase
      .from('system_ai_prompts')
      .insert([{
        name: promptData.name.trim(),
        type: promptData.type || 'Prompt',
        body: promptData.body || '',
        directions: promptData.directions || null,
        updatable_fields: promptData.updatable_fields || [],
        context_data: promptData.context_data || []
      }])
      .select()
      .single();

    if (error) throw error;
    return data;
  } catch (error) {
    logger.error('Error creating system AI prompt:', error);
    throw error;
  }
};

/**
 * Update an existing system AI prompt
 */
export const updateSystemAIPrompt = async (promptId, promptData) => {
  try {
    const { data, error } = await supabase
      .from('system_ai_prompts')
      .update({
        name: promptData.name.trim(),
        type: promptData.type || 'Prompt',
        body: promptData.body || '',
        directions: promptData.directions || null,
        updatable_fields: promptData.updatable_fields || [],
        context_data: promptData.context_data || []
      })
      .eq('id', promptId)
      .select()
      .single();

    if (error) throw error;
    return data;
  } catch (error) {
    logger.error('Error updating system AI prompt:', error);
    throw error;
  }
};

/**
 * Delete a system AI prompt
 */
export const deleteSystemAIPrompt = async (promptId) => {
  try {
    const { error } = await supabase
      .from('system_ai_prompts')
      .delete()
      .eq('id', promptId);

    if (error) throw error;
  } catch (error) {
    logger.error('Error deleting system AI prompt:', error);
    throw error;
  }
};
